import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import ClientPortalLanding from "pages/ClientPortalLanding";

function AppRoutes() {
  const location = useLocation();

  // ✅ Reset state when user returns home after checkout result

  return (
    <>
      {/* ✅ Always visible Navbar */}
      <Navbar />

      {/* ✅ Page content */}
     <Routes>
        <Route path="/:referral_code" element={<ClientPortalLanding />} />
        <Route path="/" element={<ClientPortalLanding />} />
      </Routes>
      {/* ✅ Global FAQ Section (visible on ALL pages) */}
      
      {/* ✅ Always visible Footer */}
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
